module.exports = __webpack_public_path__ + "static/img/1.5476f21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Nya/1.jpg
// module id = a6pz
// module chunks = 0